import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  HashRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { createBrowserHistory } from "history";

// core components
import AutoLogin from "views/admin/pages/AutoLogin.js";
import DashboardAdminPage from "views/admin/pages/Dashboard.js";
import Report from "views/admin/pages/ReportTask.js";
import Agent from "views/admin/pages/FieldAgent.js";
import Applicant from "views/admin/pages/FieldAgent/Applicant/Applicant";
import BankInformation from "views/admin/pages/FieldAgent/BankInformation/BankInformation";
import Document from "views/admin/pages/FieldAgent/Document/Document";
import Review from "views/admin/pages/FieldAgent/Review";
import DisbursalDetails from "views/admin/pages/FieldAgent/Disbursal/DisbursalDetails";
import Nominee from "views/admin/pages/FieldAgent/Nominee";
import Esign from "views/admin/pages/FieldAgent/Esign";
import Application from "views/admin/pages/FieldAgent/Application/Application";
import ReportGenerate from "views/admin/pages/ReportGenerate";
import AadharOAuth2RedirectHandler from "views/admin/pages/FieldAgent/AadharOAuth2RedirectHandler"
import MainContainer from "components/UpdateUi/MainContainer";
import InProess from "views/admin/pages/FieldAgent/Application/InProcess";
import Submitted from "views/admin/pages/FieldAgent/Application/Submitted";
import Disbursal from "views/admin/pages/FieldAgent/Application/Disbursal";
import Completed from "views/admin/pages/FieldAgent/Application/Completed";
import Rejected from "views/admin/pages/FieldAgent/Application/Rejected";
import ForApproval from "views/admin/pages/FieldAgent/Application/ForApproval";
import DisbursToLMS from "views/admin/pages/FieldAgent/Application/DisbursToLms";
import CollateralEvaluationApproval from "views/admin/pages/FieldAgent/Application/CollatralEvaluationApproval";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import PersonalLoan from "views/admin/pages/FieldAgent/Application/PeronalLoan";
import AdminPanel from "views/admin/pages/FieldAgent/AdminPanel/AdminPanel";
import LivePhotoAuthRedirectHandler from "views/admin/pages/FieldAgent/Document/LivePhotoAuthRedirectHandler";
import FieldAgentTabsScreen from "views/admin/pages/FieldAgent/Application/FieldAgentTabsScreen/FieldAgentTabsScreen";
import DiscrepancyApproval from "views/admin/pages/FieldAgent/Application/DiscrepancyApproval/DiscrepancyApproval";
import DeviationMasterApproval from "views/admin/pages/FieldAgent/Application/DeviationMaster/DeviationMasterApproval";
import PreSanctionApproval from "views/admin/pages/FieldAgent/Application/PreSanctionApproval/PreSanctionApproval";
import CollateralApproval from "views/admin/pages/FieldAgent/Application/CollateralApproval/CollateralApproval";
import PersonalLoanReview from "views/admin/pages/FieldAgent/PersonalDataReview/PersonalLoanReview";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import CriffCalculator from "views/admin/pages/FieldAgent/CriffCalculator/CriffCalculator";
import WebSocketChat from "components/Websocket/WebSocket";

const hist = createBrowserHistory();

const updateFavicon = (newFavicon) => {
  console.log(newFavicon,"data111")

  const favicon = document.getElementById('dynamic-favicon');
  if (favicon) {
    favicon.href = newFavicon;
  } else {
    const link = document.createElement('link');
    link.id = 'dynamic-favicon';
    link.rel = 'shortcut icon';
    link.href = newFavicon;
    document.head.appendChild(link);
  }
};
const App=()=> {
  const [appKey, setAppKey] = React.useState(0);
  const [branchName, setBranchName] = React.useState("");
  const [featureFlags, setFeatureFlags] = React.useState("");
  const [callInProgress, setCallInProgress] = React.useState(false);
  const [notifications, setNotifications] = useState([]);
  const reloadApp = () => {
    setAppKey(prev => prev + 1);
  };
  useEffect(() => {
    getFeatureFlag();
  }, []);
  const getFeatureFlag = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.FEATURE_FLAG,
    });
    updateFavicon(result?.data?.faviconUrl);
    setFeatureFlags(result?.data);
    setCallInProgress(false);
  };

  if(callInProgress){
    return <CircularProgresss callInProgress={callInProgress} />
  }
  return (
    <BrowserRouter history={hist}>
       <WebSocketChat setNotifications={setNotifications} featureFlag={featureFlags}/>
      <Routes>
        <Route path="/auto/:autoId" element={<AutoLogin />} />
        <Route path="aadhar-oauth" element={<AadharOAuth2RedirectHandler />} />
        <Route path="selfie-liveness" element={<LivePhotoAuthRedirectHandler />} />
        <Route path="/fieldAgent/:loanApplicationId" element={<FieldAgentTabsScreen seletedBranchCode={branchName} featureFlags={featureFlags} key={appKey} onReload={reloadApp} branchName={branchName} setBranchName={setBranchName}/>} />
        <Route path="/personalLoanDetails/:loanApplicationId" element={<PersonalLoanReview seletedBranchCode={branchName} featureFlags={featureFlags} key={appKey} onReload={reloadApp} branchName={branchName} setBranchName={setBranchName}/>} />
        <Route path="/loanservice" element={<MainContainer key={appKey} onReload={reloadApp} branchName={branchName} setBranchName={setBranchName} notifications={notifications} setNotifications={setNotifications}/>}>
          <Route path="dashboard" element={<DashboardAdminPage seletedBranchCode={branchName} featureFlags={featureFlags}/>} />
          <Route path="fieldagent" element={<Agent seletedBranchCode={branchName}/>} />
          <Route path="reports" element={<Report seletedBranchCode={branchName}/>} />
          <Route path="generateReports" element={<ReportGenerate seletedBranchCode={branchName}/>} />
          <Route path="application" element={<Application seletedBranchCode={branchName} featureFlags={featureFlags}/>} />
          <Route path="applicant/:loanApplicationId" element={<Applicant  seletedBranchCode={branchName}/>} />
          <Route
            path="bankInformation/:loanApplicationId"
            element={<BankInformation  seletedBranchCode={branchName}/>}
          />
          <Route path="document/:loanApplicationId" element={<Document  seletedBranchCode={branchName}/>} />
          <Route path="esign/:loanApplicationId" element={<Esign  seletedBranchCode={branchName}/>} />
          <Route path="review/:loanApplicationId" element={<Review  seletedBranchCode={branchName}/>} />
          <Route path="disbursaldetails" element={<DisbursalDetails  seletedBranchCode={branchName}/>} />
          <Route path="nominee" element={<Nominee  seletedBranchCode={branchName}/>} />
          <Route path="inProcess" element={<InProess seletedBranchCode={branchName} featureFlags={featureFlags} version={"V1"}/>} />
          <Route path="inProcess/V2" element={<InProess seletedBranchCode={branchName} featureFlags={featureFlags} version={"V2"}/>} />
          <Route path="submitted" element={<Submitted seletedBranchCode={branchName} featureFlags={featureFlags}/>}/>
          <Route path="disbursal" element={<Disbursal seletedBranchCode={branchName} featureFlags={featureFlags} />}/>
          <Route path="disbursLms" element={<DisbursToLMS seletedBranchCode={branchName} featureFlags={featureFlags}/>}/>
          <Route path="completed" element={<Completed seletedBranchCode={branchName} featureFlags={featureFlags}/>}/>
          <Route path="rejected" element={<Rejected seletedBranchCode={branchName} featureFlags={featureFlags}/>}/>
          <Route path="PersonalLoan" element={<PersonalLoan seletedBranchCode={branchName}/>}/>
          <Route path="collateralEvaluation" element={<CollateralEvaluationApproval seletedBranchCode={branchName}  featureFlags={featureFlags}/>}/>
          <Route path="preSanction" element={<PreSanctionApproval seletedBranchCode={branchName} featureFlags={featureFlags}/>}/>
          <Route path="deviation" element={<DeviationMasterApproval seletedBranchCode={branchName}/>}/>
          <Route path="collateralApproval" element={<CollateralApproval seletedBranchCode={branchName}/>}/>
          <Route path="discrepancyApproval" element={<DiscrepancyApproval seletedBranchCode={branchName}/>}/>
          <Route path="approval" element={<ForApproval seletedBranchCode={branchName} featureFlags={featureFlags}/>}/>
          <Route path="goldLoanCalculator" element={<CriffCalculator featureFlags={featureFlags}/>}/>
          <Route path="rejectApplication" element={<AdminPanel seletedBranchCode={branchName}/>}/>
        </Route>
        <Route path="*" element={<Navigate to="/loanservice/dashboard"  seletedBranchCode={branchName}/>} />

        {/* <Route path="*" element={<DashboardAdminPage/>} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App
